// Klubový preseason profil — přáteláky, výkony a redakční poznatky jednoho klubu.
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowsClockwise } from "@phosphor-icons/react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";
import { MatchCard, TREND_CLS } from "./PreseasonDatabase";

export default function PreseasonClub() {
    const { key } = useParams();
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        api.get(`/preseason-db/club/${key}`, { timeout: 30000 })
            .then((r) => setData(r.data))
            .catch(() => setErr("Klub nenalezen"));
    }, [key]);

    if (err) return <AppShell><p className="font-mono text-[11px] text-red-300 p-6">{err}</p></AppShell>;
    if (!data) return <AppShell><div className="p-8 font-mono text-[11px] text-white/50 flex items-center gap-2"><ArrowsClockwise size={13} className="animate-spin" /> Načítám…</div></AppShell>;

    const c = data.club;
    return (
        <AppShell>
            <div className="space-y-5" data-testid="psdb-club-page">
                <Link to="/preseason/database" className="font-mono text-[10px] uppercase tracking-widest text-white/45 hover:text-fa-sky inline-flex items-center gap-1.5">
                    <ArrowLeft size={11} /> Preseason databáze
                </Link>
                <header className="border-2 border-fa-sky/40 p-6">
                    <h1 className="font-display font-black uppercase tracking-tight text-3xl">{c.name}</h1>
                    <div className="flex gap-3 mt-2 font-mono text-[10px] text-white/55 flex-wrap">
                        {c.competition && <span>{c.competition}</span>}
                        {c.status && <span className="px-2 py-0.5 border border-white/20">{c.status}</span>}
                        {c.monitoring_active != null && <span className={c.monitoring_active ? "text-fa-mint" : "text-white/40"}>{c.monitoring_active ? "● Aktivně hlídáno" : "○ Nehlídáno"}</span>}
                        {c.last_known_match && <span>Poslední zápas: {c.last_known_match}</span>}
                    </div>
                    {c.notes && <p className="font-mono text-[11px] text-white/65 mt-2">{c.notes}</p>}
                </header>

                <section className="space-y-2">
                    <h2 className="font-display font-black uppercase text-lg">Přáteláky ({data.matches.length})</h2>
                    <div className="grid lg:grid-cols-2 gap-2">
                        {data.matches.map((m) => <MatchCard key={m.unique_key} m={m} />)}
                        {data.matches.length === 0 && <p className="font-mono text-[10px] text-white/45">Zatím žádné zapsané zápasy.</p>}
                    </div>
                </section>

                <section className="space-y-2">
                    <h2 className="font-display font-black uppercase text-lg">Výkony hráčů ({data.performances.length})</h2>
                    <div className="border border-white/10 bg-[#0d0d0d] overflow-x-auto">
                        <table className="w-full text-left">
                            <thead>
                                <tr className="font-mono text-[8px] uppercase tracking-widest text-white/40 border-b border-white/10">
                                    <th className="px-3 py-2">Hráč</th><th className="px-3 py-2">Datum</th>
                                    <th className="px-3 py-2 text-right">Min</th><th className="px-3 py-2 text-center">Start</th>
                                    <th className="px-3 py-2">Role</th><th className="px-3 py-2 text-right">G+A</th>
                                    <th className="px-3 py-2">Trend</th><th className="px-3 py-2">Poznámka</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.performances.map((p) => (
                                    <tr key={p.unique_key} className="border-b border-white/5 font-mono text-[10px]">
                                        <td className="px-3 py-1.5 font-display font-bold text-[12px]">{p.player_name}</td>
                                        <td className="px-3 py-1.5 text-white/45 tabular-nums">{p.date}</td>
                                        <td className="px-3 py-1.5 text-right tabular-nums text-white/80">{p.minutes ?? "Neověřeno"}</td>
                                        <td className="px-3 py-1.5 text-center">{p.started === true ? "✓" : p.started === false ? "—" : "?"}</td>
                                        <td className="px-3 py-1.5 text-white/55">{p.role}</td>
                                        <td className="px-3 py-1.5 text-right tabular-nums">{(p.goals ?? 0) + (p.assists ?? 0) || ""}</td>
                                        <td className={`px-3 py-1.5 ${TREND_CLS(p.trend)}`}>{p.trend || "Neověřeno"}</td>
                                        <td className="px-3 py-1.5 text-white/55 max-w-xs">{p.notes}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </AppShell>
    );
}
